import * as t from 'io-ts';
import { isUndefined } from 'lodash-es';

import type { TextInputDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';

export interface SubtitleSettingDefinition extends TextInputDefinition {
    key: 'SUBTITLE';
}

const definition: SubtitleSettingDefinition = {
    key: 'SUBTITLE',
    label: 'Subtitle',
    type: 'TextInput',
    value: '',
    scope: 'designer',
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.string);

export const codec = specSettingsInterface.input;

export const SubtitleSettingDefinition = define({
    key: 'SUBTITLE',
    label: 'subtitle',
    definition,
    fromSetting: (settings, _, view) =>
        specSettingsInterface.extractValue(settings.subtitle) || (view ? undefined : ''),
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        isUndefined(settings.subtitle)
            ? // even if setting is not defined, we still want it to be available
              definition
            : specSettingsInterface.createDefinitionWithSettings(settings.subtitle),
});
